import { render, staticRenderFns } from "./Debts.vue?vue&type=template&id=4c55361e&scoped=true&"
import script from "./Debts.vue?vue&type=script&lang=js&"
export * from "./Debts.vue?vue&type=script&lang=js&"
import style0 from "./Debts.vue?vue&type=style&index=0&id=4c55361e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55361e",
  null
  
)

export default component.exports